import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);

@Pipe({ name: 'weekDateToCustomLabel' })
export class WeekDateToCustomLabelPipe implements PipeTransform {
  transform(value: string, format: string = 'DD/MM/YYYY'): string {
    const givenDate = dayjs(value);
    const startOfWeek = dayjs().startOf('isoWeek');
    const endOfWeek = dayjs().endOf('isoWeek');

    if (givenDate.isSameOrAfter(startOfWeek) && givenDate.isSameOrBefore(endOfWeek)) {
      return `${givenDate.format(format)} (Esta semana)`;
    }

    return givenDate.format(format);
  }
}
